import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ModalComponent from '../../../../components/common-components/modal/ModalComponent'
import Button from '../../../../components/common-components/button/Button'
import Icons from '../../../../components/icons/Icons'
import Label from '../../../../components/common-components/label/Label'
import DatePicker from '../../../../components/common-components/datePicker'
import Input from '../../../../components/common-components/input/Input'
import { BUTTON_VARIANTS } from '../../../../components/common-components/button/Constants'
import TextArea from '../../../../components/common-components/textArea/TextArea'
import { Form, Formik } from 'formik'
import { SURGICAL_HISTORY_FORM_FIELDS_NAMES } from './Constants'
import { getValidationSchema } from '../../../../libs/formsUtils'
import { componentKey as PatientHistoryComponentKey } from '../History/PatientHistorySlice';
import { componentKey as PatientDashboardComponentKey } from '../PatientDashboardSlice';
import {
    postPatientHistory, updatePatientHistory,
} from '../History/PatientHistorySaga';


const fields = [
    { fieldName: SURGICAL_HISTORY_FORM_FIELDS_NAMES.SURGERGY_NAME, isRequired: true },
    { fieldName: SURGICAL_HISTORY_FORM_FIELDS_NAMES.SURGERY_DATE, isRequired: true },


];

const validationSchema = getValidationSchema(fields)

function PastSurgicalHistoryModal({ open, close }) {

    const dispatch = useDispatch();
    const { isSurgicalHistoryModalOpen, surgicalHistoryData, currentSurgicalHistoryId, isNewSurgicalHistoryAdd } = useSelector(
        (state) => state[PatientHistoryComponentKey]
    );

    const { currentPatientId } = useSelector((state) => state[PatientDashboardComponentKey]);

    return (
        <Formik
            initialValues={{
                [SURGICAL_HISTORY_FORM_FIELDS_NAMES.SURGERGY_NAME]: surgicalHistoryData?.surgeryName,
                [SURGICAL_HISTORY_FORM_FIELDS_NAMES.SURGERY_DATE]: surgicalHistoryData?.surgeryDate,
                [SURGICAL_HISTORY_FORM_FIELDS_NAMES.NOTE]: surgicalHistoryData?.note
            }}
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={(formVals) => {
                try {
                    if (isNewSurgicalHistoryAdd) {
                        dispatch(postPatientHistory({ patientId: currentPatientId, historyData: formVals, historyType: 'psh' }));
                    } else {
                        dispatch(
                            updatePatientHistory({
                                patientId: currentPatientId,
                                historyId: currentSurgicalHistoryId,
                                historyData: formVals,
                                historyType: 'psh'
                            })
                        );
                    }
                } catch (error) {
                    console.log(error);
                }
            }}
        >
            {({ submitForm, isSubmitting, handleSubmit, values, setFieldValue, handleBlur }) => {
                return <Form onSubmit={handleSubmit} >

                    <ModalComponent
                        open={isSurgicalHistoryModalOpen}
                        title={isNewSurgicalHistoryAdd ? 'Add Past Surgical History' : 'Update Past Surgical History'}
                        footerButton={<Button variant={BUTTON_VARIANTS.CONTAINED} customBtnClass="text-met-primary" type='submit'>Save</Button>}
                        icon={<Icons iconName="closeIcon" />}
                        close={close}
                        customClasses="w-[594px]">
                        <div className='p-2'>
                            <div>
                                <div className='pt-6'>
                                    <Label fontWeight='bold' isRequired>Surgery Name</Label>
                                </div>
                                <div>
                                    <Input
                                        placeholder={"Enter Surgery Name"}
                                        name={SURGICAL_HISTORY_FORM_FIELDS_NAMES.SURGERGY_NAME}
                                        value={values[SURGICAL_HISTORY_FORM_FIELDS_NAMES.SURGERGY_NAME]}
                                        onChangeCb={(e) => { setFieldValue(SURGICAL_HISTORY_FORM_FIELDS_NAMES.SURGERGY_NAME, e.target.value) }}
                                        onBlurCb={handleBlur}
                                    />
                                </div>
                            </div>
                            <div className='flex-1 min-w-[280px] max-w-[280px] pt-6'>
                                <div className='flex-1'>
                                    <DatePicker
                                        label="Surgery Date"
                                        placeholder='Choose Date'
                                        name={SURGICAL_HISTORY_FORM_FIELDS_NAMES.SURGERY_DATE}
                                        isRequired={true}
                                        maxDate={new Date()}
                                        value={values[SURGICAL_HISTORY_FORM_FIELDS_NAMES.SURGERY_DATE]}
                                        onChangeCb={(date) => {
                                            setFieldValue(SURGICAL_HISTORY_FORM_FIELDS_NAMES.SURGERY_DATE, date)
                                        }} />
                                </div>
                            </div>
                            <div >
                                <div className='min-w-[280px] max-w-[280px] pt-6'>
                                    <Label fontWeight='bold'>Note</Label>
                                </div>
                                <div className='mt-2'>
                                    <TextArea
                                        name={SURGICAL_HISTORY_FORM_FIELDS_NAMES.NOTE}
                                        value={values[SURGICAL_HISTORY_FORM_FIELDS_NAMES.NOTE]}
                                        onChangeCb={(e) => { setFieldValue(SURGICAL_HISTORY_FORM_FIELDS_NAMES.NOTE, e.target.value) }} />
                                </div>
                            </div>
                        </div>
                    </ModalComponent>
                </Form>
            }}
        </Formik>
    )
}

export default PastSurgicalHistoryModal